import type { IconNode, LucideIcon } from 'lucide-react'
import { createLucideIcon } from 'lucide-react'

// Scissor lift. Redrawn as a stroked outline, replacing the expanded-stroke fill that
// used to be the one glyph in the set painted differently from the rest.
export const AERIAL_LIFT_NODES: IconNode = [
  [
    'path',
    {
      key: 'aerial-lift-0',
      d: 'M6 5.75V2.75H18V5.75M5 5.75H19M8 5.75L16 11.75L8 17.75M16 5.75L8 11.75L16 17.75M4 17.75H20',
    },
  ],
  [
    'path',
    {
      key: 'aerial-lift-1',
      d: 'M7.5 21.25C8.32843 21.25 9 20.5784 9 19.75C9 18.9216 8.32843 18.25 7.5 18.25C6.67157 18.25 6 18.9216 6 19.75C6 20.5784 6.67157 21.25 7.5 21.25Z',
    },
  ],
  [
    'path',
    {
      key: 'aerial-lift-2',
      d: 'M16.5 21.25C17.3284 21.25 18 20.5784 18 19.75C18 18.9216 17.3284 18.25 16.5 18.25C15.6716 18.25 15 18.9216 15 19.75C15 20.5784 15.6716 21.25 16.5 21.25Z',
    },
  ],
]

export const AerialLiftIcon: LucideIcon = createLucideIcon(
  'aerial-lift',
  AERIAL_LIFT_NODES,
)
